import React from 'react'
import { Navigate } from 'react-router-dom'
import { useMe } from '../../api/user'
import { REDIRECT_AUTHENTICATED_PATH } from './RedirectPath'

const UserRedirectRoute = () => {
  const { data, isLoading } = useMe()

  if (isLoading) return <></>

  if (!data) return <Navigate to='/user/sign-in' />

  return <Navigate to={REDIRECT_AUTHENTICATED_PATH} />
}

export default UserRedirectRoute
